import {FC} from "react";
import IconClose from "../../assets/icons/icon_close.svg";
import IconMolecule from "../../assets/icons/molecule_icon.svg";
import {ITypeRadar} from "../../types";

interface IProps {
  isMoleculaRadarActive: boolean;
  moleculaActiveTitle: string;
  onCloseMoleculaRadar: () => void;
  setTypeRadar: (arg0: ITypeRadar) => void;
}

export const TitleMoleculeBarTopFind: FC<IProps> = ({
  isMoleculaRadarActive,
  moleculaActiveTitle,
  onCloseMoleculaRadar,
  setTypeRadar,
}) => {
  return (
    <>
      {isMoleculaRadarActive && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginTop: 20,
          }}
        >
          <div
            style={{
              fontSize: 16,
              height: "auto",
              width: "100%",
              padding: "8px 10px",
              borderRadius: 8,
              background: "linear-gradient(to bottom, #076873, transparent)",
              border: "1px solid #00F0FF",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 15,
              fontWeight: 400,
              maxWidth: 286,
              lineHeight: "1.2",
            }}
          >
            <img src={IconMolecule} alt="molecule" width={25} height={30} />
            {moleculaActiveTitle}
            <img
              src={IconClose}
              onClick={() => {
                setTypeRadar("map");
                onCloseMoleculaRadar();
              }}
              alt="close"
              width={18}
              height={18}
              style={{cursor: "pointer"}}
            />
          </div>
        </div>
      )}
    </>
  );
};
